import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { TbArrowNarrowRight, TbLock } from 'react-icons/tb';
import {
  Button,
  Card,
  Modal,
  ModalCloseButton,
  ModalFooter,
  ModalSpecializedBanner,
  Section,
  SectionSubtitle,
  SectionText,
} from '..';
import * as Styled from './styled';
import type { CheckoutConfirmationModalProps } from './types';

export * from './types';

export const CheckoutConfirmationModal: FC<CheckoutConfirmationModalProps> = (props) => {
  const { translate } = useTranslation();
  const { modal, onConfirm, illustration, loading = false, priceValue } = props;

  return (
    <Modal {...modal}>
      {/* Beware when using dropdowns or date picker inside this modal */}
      <Card size="small" isModal containerProps={{ style: { overflow: 'hidden' } }}>
        <ModalCloseButton modal={modal} />
        <Section centerChildren>
          <Styled.ModalSectionTitle>
            {translate('common.modals.checkout.title')}
          </Styled.ModalSectionTitle>

          {illustration}

          <SectionSubtitle>{translate('common.modals.checkout.subtitle')}</SectionSubtitle>

          <Styled.TextContainer>
            <SectionText
              dangerouslySetInnerHTML={{
                __html: translate('common.modals.checkout.content').replace(
                  '$price',
                  priceValue.toString(),
                ),
              }}
            />
          </Styled.TextContainer>

          <Button
            color="blue"
            onClick={onConfirm}
            iconRight={<TbArrowNarrowRight />}
            iconLeft={<TbLock />}
            loading={loading}
            shrink
          >
            {translate('common.buttons.goToPayment')}
          </Button>
        </Section>

        <Section>
          <ModalSpecializedBanner />
        </Section>

        <ModalFooter
          tag={translate('common.modals.checkout.footer.tag')}
          text={translate('common.modals.checkout.footer.text')}
        />
      </Card>
    </Modal>
  );
};
